import { Injectable } from "@angular/core";
import { UserConfigurationDB } from "@app/core/user/data/local/user-configuration-db";

/**
 * Data Access Object for the first time user uses the application.
 */
@Injectable({
  providedIn: "root",
})
export class UserConfigurationDao {
  private readonly USER_CONFIGURATION_KEY = "user-configuration";

  get(): UserConfigurationDB | null {
    const userConfiguration = window.localStorage.getItem(this.USER_CONFIGURATION_KEY);
    return userConfiguration != null ? JSON.parse(userConfiguration) : null;
  }

  set(userConfiguration: UserConfigurationDB): void {  
    window.localStorage.setItem(
      this.USER_CONFIGURATION_KEY,
      JSON.stringify(userConfiguration)
    );
  }

  delete(): void {
    window.localStorage.removeItem(this.USER_CONFIGURATION_KEY);
  }
}
